import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FileInputComponentDef } from '@df/ui/form/file-input.component.def';
@Component({
    selector: 'file-input',
    templateUrl: 'file-input.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class FileInputComponent extends FileInputComponentDef {
}
